module.exports = __webpack_public_path__ + "static/media/robot.4742cfa3.svg";